<template>
  <v-chip
      :color="color"
      :text-color="textColor"
      :x-small="xs"
      :small="small"
      :outlined="outlined"
      :link="link"
      :close="close"
      :class="{
        'chip': true,
        'label': label,
        'font-weight-bold': !noBold,
        'un-clickable': unClickable,
        rectangle,
      }"
      :ripple="!unClickable"
      :close-icon="closeIcon"
      @click="$emit('click')"
      @click:close="$emit('close')"
  >
    <slot/>
  </v-chip>
</template>

<script>
export default {
  type: "atom",
  name: "Chip",
  props: {
    color: {
      type: String
    },
    textColor: {
      type: String
    },
    link: {
      type: Boolean,
      default: false
    },
    label: { // cursorをnormalのものにする
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    closeIcon: {
      type: String,
      default: "mdi-close"
    },
    size: {
      type: String,
      default: 'xs'
    },
    outlined: {
      type: Boolean,
      default: false
    },
    rectangle: {
      type: Boolean,
      default: false,
    },
    noBold: {
      type: Boolean,
      default: false,
    },
    unClickable: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    xs() {
      return this.size === 'xs'
    },
    small() {
      return this.size === 'small'
    }
  }
}
</script>

<style scoped lang="sass">
.chip
  width: fit-content

  &.label
    cursor: default

.rectangle
  border-radius: 4px
  
.un-clickable
  cursor: default
  box-shadow: none !important
</style>